<template>
  <div v-if="src !== ''"
       class="ym-video-component"
       :class="{ 'active': !playing }"
       @click="handleVideoPlay"
  >
    <ym-img v-if="!playing && poster"
            class="banner"
            :src="poster"
            alt="封面图"
    />
    <video v-else
           id="ym-video-component"
           :src="src"
           controls
           preload="auto"
           controlslist="nodownload"
           @play="handlePlay"
           @pause="handlePause"
           @ended="handleEnd"
    ></video>
    <ym-icon class="ym-video-play-icon"
              :class="{ 'active': playing }"
              name="round-play"
    />
  </div>
</template>

<script>
  export default {
    name: 'YmVideoComponent',
    data() {
      return {
        playing: false,
      };
    },
    props: {
      src: {
        type: String,
        required: true,
      },
      poster: {
        type: String,
        default: '',
      },
    },
    methods: {
      handleVideoPlay() {
        this.playing = true;
        this.$nextTick(() => {
          document.getElementById('ym-video-component').play();
        });
      },
      handlePlay() {
        this.$emit('handlePlay');
      },
      handlePause() {
        this.$emit('handlePause');
      },
      handleEnd() {
        this.$emit('handleEnd');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ym-video-component {
    background: @background-color-base;
    width: 100%;
    height: 100%;
    position: relative;
    &.active {
      &:after {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        border-radius: @border-radius-base;
        background: fade(@color-text-base, 50%);
        left: 0;
        top: 0;
      }
    }
  }

  .ym-video-play-icon {
    position: absolute;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    font-size: @font-size-extra-large * 2;
    color: @color-white;
    z-index: @z-index-medium;
    &.active {
      display: none;
    }
  }

  video, .banner {
    width: 100%;
    height: 100%;
    display: block;
  }

</style>
